
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/tour-operators",
      function () {
        return require("private-next-pages/business/tour-operators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/tour-operators"])
      });
    }
  